import { ApiUtil as api } from '@/utils/api.util.js'

export class PermissionService {
  static URL = process.env.API_URL + process.env.API_VER
  static RESOURCE = '/permissions/'

  static all (queryParams = {}) {
    return api.get(this.URL + this.RESOURCE, queryParams)
  }
	static toggleTag(queryParams = {}) {
	    return api.post(this.URL + this.RESOURCE + 'toggle/tag', queryParams)
	}
	static getTags(queryParams = {}) {
	    return api.get(this.URL + this.RESOURCE + 'get/tags', queryParams)
	}
}



// WEBPACK FOOTER //
// ./src/services/permission.service.js